<template>
    <a ref="link" :href="href" @click="sendOutboundEvent">
        <slot></slot>
    </a>
</template>
<script>
export default {
    props: ['href'],
    methods: {
        sendOutboundEvent(event) {
            event.preventDefault();
            gaTracking.sendEvent('Outbound', 'click', this.href);
            window.open(this.href, this.$refs.link.target || '_self');
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/LinkElements/HtmlLink.vue